let themingIsEnabled: boolean = false;

export const setThemingIsEnabled = (isEnabled: boolean) => {
  themingIsEnabled = isEnabled;
};

// Task 4364092 Clean-up when 'SharedUXThemingIsEnabled' BRS and Flighting is cleaned-up
export function isThemingEnabled(): boolean {
  return themingIsEnabled;
}
